import React from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    Input,
    InputGroup,
    InputGroupText,
    Label,
} from 'reactstrap';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faInfoCircle,
    faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { addClientTimesheetContractPhaseAdjustmentSafe } from './CrewTimesheet';
import AdjustmentDetail from './AdjustmentDetail';

export default class TimesheetPhaseMaterialInput extends React.Component {
    getUnderlyingTimesheetContractPhase() {
        const { timesheet, timesheetContractPhaseAdjustment } = this.props;

        if (
            !timesheetContractPhaseAdjustment ||
            !timesheetContractPhaseAdjustment.timesheetContractPhaseId
        ) {
            return null;
        }

        return timesheet.timesheetContractPhases.find(
            (tcp) =>
                tcp.id ==
                timesheetContractPhaseAdjustment.timesheetContractPhaseId
        );
    }

    getUnderlyingTimesheetPhaseMaterial() {
        const { timesheetPhaseMaterialAdjustment } = this.props;

        const underlyingTimesheetContractPhase =
            this.getUnderlyingTimesheetContractPhase();

        if (
            !timesheetPhaseMaterialAdjustment ||
            !underlyingTimesheetContractPhase
        ) {
            return null;
        }

        return underlyingTimesheetContractPhase.timesheetPhaseMaterials.find(
            (tpm) =>
                tpm.phaseMaterialId ==
                timesheetPhaseMaterialAdjustment.phaseMaterialId
        );
    }

    onTimesheetPhaseMaterialQuantityChange = (dataContainer, e) => {
        if (!dataContainer || !e || !e.target) {
            return;
        }

        const { timesheet, job, isAdmin, onTimesheetMutated } = this.props;

        const { contractPhaseId, phaseMaterialId } = dataContainer;

        const quantity = e.target.value;

        if (isAdmin) {
            addClientTimesheetContractPhaseAdjustmentSafe(
                timesheet,
                job,
                contractPhaseId
            );

            timesheet.timesheetContractPhaseAdjustments.forEach((tcpa) => {
                if (tcpa.contractPhaseId != contractPhaseId) {
                    return;
                }

                tcpa.timesheetPhaseMaterialAdjustments.forEach((tpma) => {
                    if (tpma.phaseMaterialId != phaseMaterialId) {
                        return;
                    }

                    tpma.quantity = quantity;
                });
            });
        } else {
            timesheet.timesheetContractPhases.forEach((tcp) => {
                if (tcp.contractPhaseId != contractPhaseId) {
                    return;
                }

                tcp.timesheetPhaseMaterials.forEach((tpm) => {
                    if (tpm.phaseMaterialId != phaseMaterialId) {
                        return;
                    }

                    tpm.quantity = quantity;
                });
            });
        }

        onTimesheetMutated(timesheet);
    };

    onTimesheetPhaseMaterialReceivedChange = (dataContainer, e) => {
        if (!dataContainer || !e || !e.target) {
            return;
        }

        const { timesheet, job, isAdmin, onTimesheetMutated } = this.props;

        const { contractPhaseId, phaseMaterialId } = dataContainer;

        const received = e.target.value;

        if (isAdmin) {
            addClientTimesheetContractPhaseAdjustmentSafe(
                timesheet,
                job,
                contractPhaseId
            );

            timesheet.timesheetContractPhaseAdjustments.forEach((tcpa) => {
                if (tcpa.contractPhaseId != contractPhaseId) {
                    return;
                }

                tcpa.timesheetPhaseMaterialAdjustments.forEach((tpma) => {
                    if (tpma.phaseMaterialId != phaseMaterialId) {
                        return;
                    }

                    tpma.received = received;
                });
            });
        } else {
            timesheet.timesheetContractPhases.forEach((tcp) => {
                if (tcp.contractPhaseId != contractPhaseId) {
                    return;
                }

                tcp.timesheetPhaseMaterials.forEach((tpm) => {
                    if (tpm.phaseMaterialId != phaseMaterialId) {
                        return;
                    }

                    tpm.received = received;
                });
            });
        }

        onTimesheetMutated(timesheet);
    };

    render() {
        const {
            loading,
            timesheet,
            timesheetPhaseMaterial,
            timesheetPhaseMaterialAdjustment,
            job,
            timesheetContractPhase,
            timesheetContractPhaseAdjustment,
            isReadOnly,
        } = this.props;

        if (
            loading ||
            !timesheet ||
            (!timesheetPhaseMaterial && !timesheetPhaseMaterialAdjustment)
        ) {
            return null;
        }

        const timesheetContractPhaseInQuestion =
            timesheetContractPhaseAdjustment ?? timesheetContractPhase;

        const entityInQuestion =
            timesheetPhaseMaterialAdjustment ?? timesheetPhaseMaterial;

        const contractPhase = job.contract.contractPhases.find(
            (cp) => timesheetContractPhaseInQuestion.contractPhaseId == cp.id
        );

        const phaseMaterial = contractPhase.phaseMaterials.find(
            (pm) => pm.id == entityInQuestion.phaseMaterialId
        );

        const heavyBidMaterial = job.contract.heavyBidMaterials.find(
            (hbm) => hbm.id == phaseMaterial.heavyBidMaterialId
        );

        const phaseMaterialEstimateAvailable = Boolean(
            phaseMaterial && phaseMaterial.quantity
        );

        const warning =
            phaseMaterialEstimateAvailable &&
            entityInQuestion.quantity > phaseMaterial.quantity;

        const valid = !warning && entityInQuestion.quantity > 0;

        const underlyingTimesheetPhaseMaterial =
            this.getUnderlyingTimesheetPhaseMaterial();

        return (
            <Card
                className={cls('timesheet-phase-material-input-card mt-2', {
                    warning,
                    valid,
                })}
            >
                <CardHeader>
                    {heavyBidMaterial.description}

                    {phaseMaterialEstimateAvailable && (
                        <span className="ml-2 font-italic">
                            Estimated Total: {phaseMaterial.quantity}{' '}
                            {heavyBidMaterial.unitOfMeasure}
                        </span>
                    )}
                </CardHeader>
                <CardBody>
                    <AdjustmentDetail
                        entity={entityInQuestion}
                        {...this.props}
                    />
                </CardBody>
                <CardBody className="d-flex">
                    <div className="col-6">
                        <div>
                            <Label className="control-label" for="received">
                                Received
                            </Label>
                        </div>
                        <div>
                            <InputGroup>
                                <Input
                                    type="number"
                                    inputMode="decimal"
                                    id="received"
                                    value={entityInQuestion.received}
                                    onChange={this.onTimesheetPhaseMaterialReceivedChange.bind(
                                        this,
                                        {
                                            contractPhaseId: contractPhase.id,
                                            phaseMaterialId: phaseMaterial.id,
                                        }
                                    )}
                                    disabled={isReadOnly}
                                />
                                {heavyBidMaterial.unitOfMeasure && (
                                    <InputGroupText>
                                        {heavyBidMaterial.unitOfMeasure}
                                    </InputGroupText>
                                )}
                            </InputGroup>

                            {underlyingTimesheetPhaseMaterial &&
                                underlyingTimesheetPhaseMaterial.received !=
                                    entityInQuestion.received && (
                                    <div className="info">
                                        <FontAwesomeIcon
                                            icon={faInfoCircle}
                                            className="mr-1"
                                        />{' '}
                                        The original timesheet specified{' '}
                                        {
                                            underlyingTimesheetPhaseMaterial.received
                                        }{' '}
                                        {heavyBidMaterial.unitOfMeasure}{' '}
                                        received.
                                    </div>
                                )}
                        </div>
                    </div>
                    <div className="col-6">
                        <div>
                            <Label className="control-label" for="quantity">
                                Installed
                            </Label>
                        </div>
                        <div>
                            <InputGroup>
                                {warning && (
                                    <InputGroupText className="text-danger">
                                        <FontAwesomeIcon
                                            icon={faTriangleExclamation}
                                            title="Installed amount is over budget."
                                        />
                                    </InputGroupText>
                                )}
                                <Input
                                    type="number"
                                    id="quantity"
                                    inputMode="decimal"
                                    value={entityInQuestion.quantity}
                                    onChange={this.onTimesheetPhaseMaterialQuantityChange.bind(
                                        this,
                                        {
                                            contractPhaseId: contractPhase.id,
                                            phaseMaterialId: phaseMaterial.id,
                                        }
                                    )}
                                    invalid={warning}
                                    disabled={isReadOnly}
                                />
                                {heavyBidMaterial.unitOfMeasure && (
                                    <InputGroupText
                                        className={cls({
                                            'text-danger': warning,
                                        })}
                                    >
                                        {heavyBidMaterial.unitOfMeasure}
                                    </InputGroupText>
                                )}
                            </InputGroup>

                            {underlyingTimesheetPhaseMaterial &&
                                underlyingTimesheetPhaseMaterial.quantity !=
                                    entityInQuestion.quantity && (
                                    <div className="info">
                                        <FontAwesomeIcon
                                            icon={faInfoCircle}
                                            className="mr-1"
                                        />
                                        The original timesheet specified{' '}
                                        {
                                            underlyingTimesheetPhaseMaterial.quantity
                                        }{' '}
                                        {heavyBidMaterial.unitOfMeasure}{' '}
                                        installed.
                                    </div>
                                )}
                        </div>
                    </div>
                </CardBody>
            </Card>
        );
    }
}
